import { useSelector } from 'react-redux';
import { selectSearchQuery } from '../../../redux/slices/globalFilter/global-dates-filter-slice';
import { getUserSchema } from '../../../helpers/general-helpers';

export default function useStartEndDates() {
  const globalFilter = useSelector(selectSearchQuery);
  const storageGlobalFilter = (() => {
    try {
      return JSON.parse(localStorage.getItem(`${getUserSchema()}-global-filters`) || '{}');
    } catch {
      return {};
    }
  })();

  const dates = {
    startDate: '',
    endDate: '',
    quickDateRange: '',
  };

  let dateDetails;
  if (globalFilter?.value?.DateDetails?.dateStart && globalFilter?.value?.DateDetails?.dateEnd) {
    dateDetails = globalFilter?.value?.DateDetails;
  } else {
    dateDetails = storageGlobalFilter?.DateDetails;
  }

  if (dateDetails) {
    if (dateDetails?.dateStart) {
      dates.startDate = dateDetails.dateStart;
    }

    if (dateDetails.dateEnd) {
      dates.endDate = dateDetails.dateEnd;
    }
    if (dateDetails.quickDateRange?.value) {
      // Ensure only string | number is used (value is already constrained, but coerce defensively)
      dates.quickDateRange = String(dateDetails.quickDateRange.value);
    }
  }

  return dates;
}
